import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import SignOffTable from "./SignOffTable";
import { MentorQueuesData } from "../../types";
import { loadPartiallyComplete, beginSession } from "../../redux/actions/guideStreamActions";
import Loading from "../../../Shared/loading";
import { SessionStub } from "../../../Shared/GeneratedTypes";
import useInterval from "../../../Shared/useInterval";

const mapState = ({ localizations, apiCallsInProgress, waitingForSignOff }: MentorQueuesData) => ({
    waitingForSignOff,
    localizations: localizations!,
    apiCallsInProgress,
});

const mapDispatch = {
    loadPartiallyComplete,
    beginSession,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};

function SignOffPage({
    waitingForSignOff,
    loadPartiallyComplete,
    localizations,
    beginSession,
    apiCallsInProgress,
}: PropTypes) {
    // const { queuedMentors, loadQueuedMentors } = props;
    useEffect(() => {
        if (!waitingForSignOff || waitingForSignOff.length === 0) {
            loadPartiallyComplete();
        }
    }, []);

    const [secondsUntilRefresh, updateSecondsUntilRefresh] = useState(30);

    useInterval(() => {
        if (secondsUntilRefresh === 0) {
            loadPartiallyComplete();
            updateSecondsUntilRefresh(30);
        } else {
            updateSecondsUntilRefresh(secondsUntilRefresh - 1);
        }
    }, 1000);

    const refreshNow = () => {
        loadPartiallyComplete();
        updateSecondsUntilRefresh(30);
    };

    function selectMentor(session: SessionStub) {
        beginSession(session.customerId, session.id!);
    }

    return (
        <>
            {apiCallsInProgress > 0 ? (
                <>
                    <Loading message={localizations.loadingMentors} />
                </>
            ) : (
                <SignOffTable
                    refreshNow={refreshNow}
                    refreshTimer={secondsUntilRefresh}
                    signOffSessions={waitingForSignOff}
                    localizations={localizations}
                    setActive={selectMentor}
                />
            )}
        </>
    );
}

export default connector(SignOffPage);
